import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { noteListsQueryOptions } from "@/queries/noteLists";
import { ListsTable } from "@/components/lists/lists-table";

export const Route = createFileRoute("/lists/")({
  component: ListsIndexPage,
});

function ListsIndexPage() {
  const { user } = Route.useRouteContext();

  const { data: lists = [], isLoading } = useQuery(
    noteListsQueryOptions(user?.id),
  );

  return (
    <div className="p-4 md:p-6">
      <ListsTable lists={lists} isLoading={isLoading} />
    </div>
  );
}
